module.exports = __webpack_public_path__ + "img/pic_tiliao_success_yellow@2x.0fa2deb8.png";